module.exports = __webpack_public_path__ + "img/FedEx.383c9ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/FedEx.png
// module id = ukZn
// module chunks = 2